export const fmtEur = (n) => {
  const val = Number(n || 0);
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "—";
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("it-IT");
  } catch {
    return "—";
  }
};

export const STATE_LABELS = {
  bozza: "Bozza",
  da_approvare: "Da Approvare",
  da_correggere: "Da Correggere",
  approvata: "Approvata",
  inviata: "Inviata",
  accettata: "Accettata",
  rifiutata: "Rifiutata",
  scaduta: "Scaduta",
  archiviata: "Archiviata",
};

export const STATE_CLASSES = {
  bozza: "bg-slate-100 text-slate-700 border-slate-300",
  da_approvare: "bg-orange-50 text-orange-700 border-orange-300",
  da_correggere: "bg-cyan-50 text-cyan-700 border-cyan-300",
  approvata: "bg-blue-50 text-blue-700 border-blue-300",
  inviata: "bg-purple-50 text-purple-700 border-purple-300",
  accettata: "bg-green-50 text-green-700 border-green-300",
  rifiutata: "bg-red-50 text-red-700 border-red-300",
  scaduta: "bg-rose-50 text-rose-700 border-rose-300",
  archiviata: "bg-slate-100 text-slate-500 border-slate-300",
};

export const ROLE_LABELS = {
  admin: "Amministratore",
  direzione: "Direzione",
  dipendente: "Dipendente",
  commerciale: "Commerciale",
};
